import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const DEFAULTS =   {
  activeClass: 'active',
  questionSelector: '[data-accordian-question]',
  answerSelector: '[data-accordian-answer]',
  scrollOffset: 0,
  initWithExpandedIndex: undefined,
};

export default class Accordion {
  constructor(containerEl, options = DEFAULTS) {
    Object.assign(this.options = {}, DEFAULTS, options);
    this.container = containerEl;
    this.questions = containerEl.querySelectorAll(this.options.questionSelector);
    this.answers = containerEl.querySelectorAll(this.options.answerSelector);

    if (typeof this.options.initWithExpandedIndex === 'number') {
      this.showFaq(this.options.initWithExpandedIndex);
      // Call this again in case styles haven't loaded yet.
      // Needs CSS to correctly calculate the height.
      setTimeout(() => this.showFaq(this.options.initWithExpandedIndex), 1000);
    }
    this._events();

    // Hot Module Support
    if (module.hot) {
      // The original markup without eventListeners.
      this.markup = containerEl.cloneNode(true);
      // The parent element.
      this.parentEl = containerEl.parentElement;
    }
  }

  /**
   * Show a single FAQ answer, and hide all others.
   * @param  {number} index The index of the answer to show.
   */
  showFaq(index) {
    this._expandFaq(this.questions[index]);
  }

  /**
   * Collapses all FAQ answers, and remove active classes from questions
   * @return {void}
   */
  collapseAllAnswers(){
    this.questions.forEach((question) => {
      this.collapseAnswer(question);
    });
  }

  collapseAnswer(question) {
    question.classList.remove(this.options.activeClass);
    question.nextElementSibling.style.maxHeight = 0;
    question.nextElementSibling.style.visibility = 'hidden';
  }

  /**
   * Given a question element, check to see if it contains agenda classes
   * @param  {HTMLElement} question - The accordion element
   * @return {bool}
   */
  isAgendaItemExpanded(question){
    if (question.classList.contains('event-agenda__day-header--expanded')) return true;
  }

  isAgendaItemCollapsed(question){
    // Needs to check for second class because there are different accordions being used
    if (!question.classList.contains('event-agenda__day-header--expanded') && question.classList.contains('event-agenda__day-header')) return true;
  }

  /**
   * Wire up all click events
   * @return {void}
   */
  _events() {
    this.questions.forEach((question) => {
      question.addEventListener('click', () => {
        if (this.isAgendaItemExpanded(question) === true) {
          this.collapseAnswer(question);
        } else if (this.isAgendaItemCollapsed(question) === true){
          this._expandFaq(question);
          this._scrollToFaq(question);
        } else{
          this.collapseAllAnswers();
          this._expandFaq(question);
        }
      });
    });
  }

  /**
   * Given a question element, expand an FAQ answer and hide all others.
   * @param  {HTMLElement} question The FAQ question element
   * @return {void}
   */
  _expandFaq(question) {
    this._applyExpandStyleToAnswer(question);
    question.classList.add(this.options.activeClass);
  }

  /**
   * Given a question element, scroll to the FAQ that was clicked.
   * @param  {HTMLElement} question The FAQ question element
   * @return {void}
   */
  _scrollToFaq(question) {
    window.scrollTo({
      top: question.offsetTop + this.options.scrollOffset,
      behavior: 'smooth',
    });
  }

  /**
   * Apply the styles required to expand an FAQ question.
   * @param  {HTMLElement} question The FAQ question element
   * @return {void}
   */
  _applyExpandStyleToAnswer(question) {
    const answer = question.nextElementSibling;
    // Count up the height of all WYSIWYG child elements (p, ul, etc.)
    const totalHeight = [...answer.children[0].children]
      .map(el => {
        const style = window.getComputedStyle(el);
        const vertMargin = parseInt(style['margin-top']) + parseInt(style['margin-bottom']);
        const vertPadding = parseInt(style['padding-top']) + parseInt(style['padding-bottom']);
        return el.offsetHeight + vertMargin + vertPadding;
      })
      .reduce((a, b) => a + b);
    // total height of all children
    answer.style.maxHeight = `${totalHeight}px`;
    answer.style.visibility = 'visible';
  }

}
